import digitalData from 'digital-data';

export const impressionProvider = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('impression.trigger', (output) => {
    const ddoEvent = {
      category: {
        primaryCategory: 'batch'
      },
      eventInfo: {
        eventName: 'viewport impression'
      },
      clickID: output?.output?.clickID,
      container: output?.output?.container,
      impression: output?.output?.impression
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
